import { render, staticRenderFns } from "./display-field-default.vue?vue&type=template&id=65d5e5ec&scoped=true&"
import script from "./display-field-default.ts?vue&type=script&lang=ts&"
export * from "./display-field-default.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-default.scss?vue&type=style&index=0&id=65d5e5ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d5e5ec",
  null
  
)

export default component.exports